import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faLinkedin,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import { useTranslation } from "react-i18next";
import { useCookieConsent } from "../context/CookieConsentContext";

function Footer() {
  const { t } = useTranslation();
  const { reopen } = useCookieConsent();

  const cols = [
    {
      heading: t("KinoKlik EPK"),
      links: [
        { label: t("For Filmmakers"),           href: "/forFilmMakers",   external: false },
        { label: t("For Industry Professionals"), href: "/forIndustryProf", external: false },
      ],
    },
    {
      heading: t("Company"),
      links: [
        { label: t("About Us"),   href: "#aboutus",   external: true },
        { label: t("Contact Us"), href: "#contactus", external: true },
        { label: t("Support"),    href: "#support",   external: true },
      ],
    },
    {
      heading: t("Relations"),
      links: [
        { label: t("Partners"),    href: "#partners",  external: true },
        { label: t("Investors"),   href: "#investors", external: true },
        { label: t("Media & Blog"), href: "#media",    external: true },
      ],
    },
  ];

  const socials = [
    { icon: faFacebook,  href: "https://www.facebook.com/kinoklikcanada",                    label: "Facebook"  },
    { icon: faInstagram, href: "https://www.instagram.com/kinoklik",                         label: "Instagram" },
    { icon: faLinkedin,  href: "https://www.linkedin.com/company/kinoklik/?viewAsMember=true", label: "LinkedIn"  },
    { icon: faTwitter,   href: "https://twitter.com/kinoklik_canada",                        label: "Twitter"   },
  ];

  return (
    <footer className="tw-bg-[#130026] tw-border-t tw-border-[#5A3F49]/30">
      {/* Pink accent line */}
      <div className="tw-h-[2px]" style={{ background: 'linear-gradient(to right, #FF43A7 0%, rgba(255,67,167,0.3) 60%, transparent 100%)' }} />

      <div className="tw-px-6 md:tw-px-12 tw-py-6">
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-8">

          {/* Logo + socials */}
          <div className="tw-col-span-2 md:tw-col-span-1 tw-flex tw-flex-col tw-gap-3">
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-1">
              <img src={logo} alt={t("KinoKlik")} className="tw-h-7 tw-w-auto" style={{ marginLeft: '-4px' }} />
              <p className="tw-text-[#AA8894] tw-text-xs tw-leading-relaxed tw-m-0">
                {t("The professional EPK platform for the film industry.")}
              </p>
            </div>
            <div className="tw-flex tw-gap-4">
              {socials.map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="tw-text-[#AA8894] hover:tw-text-[#FF43A7] tw-transition-colors tw-no-underline tw-text-lg"
                >
                  <FontAwesomeIcon icon={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {cols.map(({ heading, links }) => (
            <div key={heading} className="tw-flex tw-flex-col tw-gap-3">
              <h2 className="tw-text-white tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-m-0">
                {heading}
              </h2>
              {links.map(({ label, href, external }) =>
                external ? (
                  <a key={label} href={href} className="tw-text-[#AA8894] hover:tw-text-white tw-text-sm tw-no-underline tw-transition-colors tw-w-fit">
                    {label}
                  </a>
                ) : (
                  <Link key={label} to={href} className="tw-text-[#AA8894] hover:tw-text-white tw-text-sm tw-no-underline tw-transition-colors tw-w-fit">
                    {label}
                  </Link>
                )
              )}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="tw-mt-8 tw-pt-6 tw-border-t tw-border-[#5A3F49]/20 tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-2">
          <p className="tw-text-[#5A3F49] tw-text-xs tw-m-0">
            &copy; {new Date().getFullYear()} {t("KinoKlik. All Rights Reserved.")}
          </p>
          <p className="tw-text-[#5A3F49] tw-text-xs tw-m-0">
            {t("Made for the film industry.")}
          </p>
          <button
            type="button"
            onClick={reopen}
            className="tw-text-[#5A3F49] hover:tw-text-white tw-text-xs tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-transition-colors"
          >
            {t("Cookie settings")}
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
